// filepath: d:\Code\photo-app\src\components\Footer.js
import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Container id="footer" className="w-75">
      <Row className="justify-content-center">
        <Col>
          <a href="mailto:enquiries@truanhickphotography.co.uk"><Image alt='Email me' src='img/email128.png' width="32" height="32"/></a>
          <a href="https://www.instagram.com/photos.by.truanh/" target='_blank' rel="noreferrer"><Image alt='View my profile on Instagram' src='img/insta128.webp' width="32" height="32"/></a>
          <a href="https://the.fotoapp.co/photos.by.truanh" target='_blank' rel="noreferrer"><Image alt='View my profile on The Foto App' src='img/foto-circle-logotype-red.png' width="32" height="32"/></a>
          <a href="https://purpleport.com/portfolio/truan/?referrer=truan" target='_blank' rel="noreferrer"><Image alt='View my portfolio on PurplePort.com' src='https://purpleport.com/i/share/purpleport.png' width="32" height="32"/></a>
          <a href="https://pin.it/5IoSNZZH6" target='_blank' rel="noreferrer"><Image alt='View my profile on Pinterest' src='img/pinterest128.webp' width="32" height="32"/></a>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          &copy;Truan Hick 2025{currentYear > 2025 ? `-${currentYear}` : ''}
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;